import { useGetKycStatusQuery, useTransferInMutation } from "apis";
import { useModalView } from "components";
import { useForm } from "hooks";
import useAuthToken from "hooks/useAuthToken";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router";
import { when, persistUrl } from "utils";
import SuccessUI from "./SuccessUI";
import ls from "utils/secureStorage";
import { useSearchParams } from "hooks";
interface SuccessViewProps {
  reset: () => void;
}

export function SuccessView(props: SuccessViewProps) {
  const { reset } = props;
  const navigate = useNavigate();
  const lastStatus = useRef("none");
  const { authToken } = useAuthToken();
  const PERSISTED_URL = persistUrl();

  const partnerType = useSearchParams("type");

  const { setCurrentView } = useModalView();
  const { isActiveQuote, quoteRes, transferId, setTransferId, setTransferData } = useForm();
  const [transferIn] = useTransferInMutation();

  const { data } = useGetKycStatusQuery(null, {
    pollingInterval: when(["expired", "rejected", "approved"].includes(lastStatus.current), undefined, 10000),
  });

  lastStatus.current = data?.status ?? "none";

  const tabType: "buy" | "sell" = ls.get("tabType");
  const fiatAccountId = ls.get("fiatAccountId");

  const status = useMemo(() => data?.status ?? "Unknown", [data]);

  const createTransfer = useCallback(async () => {
    try {
      const quoteId = quoteRes?.quote?.quoteId!;

      if (!transferId && quoteId && authToken) {
        const transferResult = await transferIn({
          quoteId,
          fiatAccountId: fiatAccountId ? fiatAccountId : undefined,
          token: authToken,
          type: tabType === "buy" || !tabType ? "in" : "out",
        }).unwrap();

        setTransferId(transferResult?.transferId);
        setTransferData(transferResult);
        navigate(`/transaction/${transferResult?.transferId}`, { replace: true });
      } else {
        navigate(`/${PERSISTED_URL}`, { replace: true });
      }
    } catch {
      navigate(`/${PERSISTED_URL}`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, quoteRes?.quote?.quoteId, transferId]);

  useEffect(() => {
    if (status === "approved" && !partnerType) {
      if (isActiveQuote()) {
        createTransfer();
      } else {
        navigate(`/${PERSISTED_URL}`, { replace: true });
      }
    } else if (status === "approved" && partnerType) {
      navigate(`/kyc-status?type=partner`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, partnerType]);

  console.log(partnerType, "FROM SUCCESS UI");

  //   const message = useMemo(() => {
  //     const map: Record<string, string> = {
  //       approved: "Your kyc has been approved",
  //       pending: "Your kyc is pending approval",
  //       rejected: "Your kyc was rejected, try again",
  //       expired: "Your kyc session expired, try again",
  //     };
  //     return map[status];
  //   }, [status]);

  const handleContinue = () => {
    if (lastStatus.current === "approved") {
      if (isActiveQuote()) navigate("/payment", { replace: true });
      else {
        navigate(`/${PERSISTED_URL}`, { replace: true });
      }
    } else if (lastStatus.current === "pending") {
    } else if (["rejected", "expired"].includes(lastStatus.current) || !status) {
      setCurrentView(0);
      reset();
    }
  };

  return <SuccessUI handleContinue={handleContinue} lastStatus={lastStatus} status={status} />;
}
